<template>
  <CrudMiembros />
</template>

<script>
import CrudMiembros from '@/components/Miembros/Crud_miembros.vue'
export default {
  name: 'MiembrosView',
  components: { CrudMiembros }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/MiembrosView.vue